export enum KeyEnum {
    TAB = 9,
    ENTER = 13,
    RIGHT_ARROW = 39,
    DOWN_ARROW = 40,
    UP_ARROW = 38
}



// WEBPACK FOOTER //
// ./src/KeyEnum.ts